(() => {
  const dialog = document.querySelector("[data-buy-now-dialog]");
  const form = document.querySelector("[data-buy-now-form]");
  const shopifyForm = document.getElementById("BuyNowShopifyForm");
  if (!dialog || !form) return;

  const productEl = form.querySelector("[data-buy-now-product]");
  const errorEl = form.querySelector("[data-buy-now-error]");
  const thanks = document.querySelector("[data-buy-now-thanks]");
  const submitBtn = form.querySelector("[data-buy-now-submit]");
  const deliveryBlock = form.querySelector("[data-delivery-block]");
  const deliveryAddress = form.querySelector("[data-delivery-address]");
  const receiverBlock = form.querySelector("[data-receiver-block]");
  const timeFrom = form.querySelector('[name="time_from"]');
  const timeTo = form.querySelector('[name="time_to"]');
  const dateInput = form.querySelector('[name="delivery_date"]');

  let order = {};

  const times = [];
  for (let h = 6; h <= 21; h += 1) {
    for (const m of [0, 30]) {
      if (h === 21 && m === 30) continue;
      const value = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      const hour12 = ((h + 11) % 12) + 1;
      const label = `${hour12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
      times.push({ value, label });
    }
  }
  const fillTimes = (select, picked) => {
    if (!select || select.options.length) return;
    times.forEach((slot) => {
      const opt = document.createElement("option");
      opt.value = slot.value;
      opt.textContent = slot.label;
      if (slot.value === picked) opt.selected = true;
      select.appendChild(opt);
    });
  };
  fillTimes(timeFrom, "09:00");
  fillTimes(timeTo, "17:00");

  const todayISO = () => {
    const now = new Date();
    const tz = now.getTime() - now.getTimezoneOffset() * 60000;
    return new Date(tz).toISOString().slice(0, 10);
  };

  const showError = (msg) => {
    if (!errorEl) return;
    errorEl.hidden = !msg;
    errorEl.textContent = msg || "";
  };

  const val = (name) => (form.elements[name]?.value || "").trim();
  const radio = (name) => {
    const picked = form.querySelector(`input[name="${name}"]:checked`);
    return picked ? picked.value : "";
  };

  const syncExtras = () => {
    const need = radio("need_delivery") === "yes";
    const otherAddr = radio("same_address") === "no";
    const otherRecv = radio("same_receiver") === "no";
    if (deliveryBlock) deliveryBlock.hidden = !need;
    if (deliveryAddress) deliveryAddress.hidden = !need || !otherAddr;
    if (receiverBlock) receiverBlock.hidden = !need || !otherRecv;
    const deliveryAddrField = form.elements.delivery_address;
    const receiverFirst = form.elements.receiver_first;
    const receiverLast = form.elements.receiver_last;
    const receiverPhone = form.elements.receiver_phone;
    if (dateInput) dateInput.required = need;
    if (timeFrom) timeFrom.required = need;
    if (timeTo) timeTo.required = need;
    if (deliveryAddrField) deliveryAddrField.required = need && otherAddr;
    if (receiverFirst) receiverFirst.required = need && otherRecv;
    if (receiverLast) receiverLast.required = need && otherRecv;
    if (receiverPhone) receiverPhone.required = need && otherRecv;
    form.querySelectorAll('input[name="payment"]').forEach((input) => {
      input.required = need;
    });
  };

  const closeDialog = (el) => {
    if (!el) return;
    if (typeof el.close === "function" && el.open) el.close();
    else el.removeAttribute("open");
  };
  const openDialog = (el) => {
    if (!el) return;
    if (typeof el.showModal === "function") el.showModal();
    else el.setAttribute("open", "");
  };
  const close = () => {
    closeDialog(dialog);
    closeDialog(thanks);
    document.body.classList.remove("buy-now-open");
    document.body.style.overflow = "";
  };
  const showThanks = () => {
    closeDialog(dialog);
    openDialog(thanks);
    document.body.classList.add("buy-now-open");
    document.body.style.overflow = "hidden";
    thanks.querySelector("[data-buy-now-thanks-close]")?.focus();
  };

  const open = (detail) => {
    order = detail || {};
    if (productEl) {
      const bits = [order.title, order.variant, order.price].filter(Boolean);
      productEl.textContent = bits.join(" · ");
    }
    if (dateInput) {
      dateInput.min = todayISO();
      if (!dateInput.value) dateInput.value = todayISO();
    }
    showError("");
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = (window.themeI18n?.t || ((k) => k))("send");
    }
    syncExtras();
    closeDialog(thanks);
    openDialog(dialog);
    document.body.classList.add("buy-now-open");
    document.body.style.overflow = "hidden";
    form.querySelector('[name="first_name"]')?.focus();
  };

  const buildMessage = () => {
    const need = radio("need_delivery") === "yes";
    const lines = [
      "BUY NOW ORDER",
      `Product: ${order.title || ""}`,
      order.variant ? `Variant: ${order.variant}` : "",
      order.sku ? `SKU: ${order.sku}` : "",
      order.price ? `Price: ${order.price}` : "",
      order.url ? `Link: ${order.url}` : "",
      "",
      `Name: ${val("first_name")} ${val("last_name")}`,
      `Phone: ${val("phone")}`,
      val("email") ? `Email: ${val("email")}` : "",
      `Home address: ${val("address")}`,
      "",
      `Needs delivery: ${need ? "Yes" : "No"}`,
    ];
    if (need) {
      const sameAddr = radio("same_address") !== "no";
      const sameRecv = radio("same_receiver") !== "no";
      lines.push(`Delivery address same as home: ${sameAddr ? "Yes" : "No"}`);
      if (!sameAddr) lines.push(`Delivery address: ${val("delivery_address")}`);
      lines.push(`Receiver same as customer: ${sameRecv ? "Yes" : "No"}`);
      if (!sameRecv) {
        lines.push(`Receiver: ${val("receiver_first")} ${val("receiver_last")}`);
        lines.push(`Receiver phone: ${val("receiver_phone")}`);
      }
      lines.push(`Delivery date: ${val("delivery_date")}`);
      lines.push(`Available: ${val("time_from")} to ${val("time_to")}`);
      lines.push(`Payment: ${radio("payment")}`);
    }
    if (val("notes")) lines.push("", `Special instructions: ${val("notes")}`);
    return lines.filter((line, i, all) => line !== "" || all[i - 1] !== "").join("\n");
  };

  const chatId = () => window.theme?.respondioWidgetId || "1dbb62a323abfdc5b9713dbff4d76fe";

  const chatIdentifier = () => {
    const digits = val("phone").replace(/\D/g, "");
    let local = digits;
    if (local.startsWith("592")) local = local.slice(3);
    if (local.startsWith("0")) local = local.slice(1);
    const id = `+592${local}`;
    return /^[A-z0-9\-=+/.@]{1,50}$/.test(id) ? id : id.slice(0, 50);
  };

  const identifyChat = () => {
    window.__respond_settings = Object.assign({}, window.__respond_settings || {}, {
      identifier: chatIdentifier(),
      firstName: val("first_name"),
      lastName: val("last_name"),
      phone: chatIdentifier(),
      email: val("email") || undefined,
      countryCode: "GY",
      language: window.themeI18n?.lang?.() === "zh" ? "zh" : (window.themeI18n?.lang?.() || "en"),
      autoDetectLanguage: false
    });
  };

  const postJson = (url, payload) => {
    const body = JSON.stringify(payload);
    try {
      navigator.sendBeacon?.(url, new Blob([body], { type: "application/json" }));
    } catch {
      /* ignore */
    }
    return fetch(url, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/json" },
      body,
    }).catch(() => {});
  };

  const postChatWebhook = (payload) => {
    const endpoint = "https://webhook.respond.io/webchat/webhook";
    const encoded = new URLSearchParams({ data: JSON.stringify(payload) });
    const body = encoded.toString();
    try {
      navigator.sendBeacon?.(endpoint, new Blob([body], { type: "application/x-www-form-urlencoded" }));
    } catch {
      /* ignore */
    }
    return fetch(endpoint, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    }).catch(() => {});
  };

  const waitForRespond = () => new Promise((resolve) => {
    if (window.$respond?.do) return resolve(true);
    let ticks = 0;
    const timer = setInterval(() => {
      ticks += 1;
      if (window.$respond?.do || ticks > 40) {
        clearInterval(timer);
        resolve(Boolean(window.$respond?.do));
      }
    }, 150);
  });

  const openWebsiteChat = async () => {
    document.body.classList.add("sf-webchat-open");
    const ready = await waitForRespond();
    if (!ready) {
      window.location.hash = "webchat_widget";
      return false;
    }
    try { window.$respond.do("chat:reinitialize"); } catch { /* ignore */ }
    try { window.$respond.do("chat:open"); } catch { /* ignore */ }
    window.setTimeout(() => window.$respond?.do?.("chat:open"), 400);
    return true;
  };

  const postToWidget = (text) => {
    const frames = [
      window.$__iframe,
      ...[...document.querySelectorAll('iframe[title="Webchat Widget"]')].map((el) => el.contentWindow),
    ].filter(Boolean);
    const payloads = [
      { event: "RESPONDIO_SEND_MESSAGE", payload: { type: "text", text } },
      { event: "RESPONDIO_ACTION_SEND", payload: { text } },
      { type: "text", text },
      { queryMessage: [{ type: "text", text }] },
    ];
    frames.forEach((win) => {
      payloads.forEach((payload) => {
        try { win.postMessage(payload, "*"); } catch { /* ignore */ }
      });
    });
  };

  const sendRespondChat = async () => {
    identifyChat();
    const cId = chatId();
    const contact = window.__respond_settings;
    const text = buildMessage();
    const sender = {
      id: contact.identifier,
      firstName: contact.firstName,
      lastName: contact.lastName,
      email: contact.email || "",
      phone: contact.phone,
      countryCode: "GY",
      lang: window.themeI18n?.lang?.() || "en",
    };
    await openWebsiteChat();
    try {
      window.$respond?.on?.("chat:opened", () => postToWidget(text));
    } catch { /* ignore */ }
    await postChatWebhook({
      sender,
      recipient: { id: cId },
      queryMessage: [{ type: "event", event: { type: "WELCOME" }, payload: null }],
    });
    await postChatWebhook({
      sender: { id: contact.identifier, firstName: contact.firstName, lastName: contact.lastName, phone: contact.phone },
      recipient: { id: cId },
      queryMessage: [{ type: "text", text }],
    });
    const servicePayload = {
      cId,
      channelId: cId,
      identifier: contact.identifier,
      contact,
      message: { type: "text", text },
      queryMessage: [{ type: "text", text }],
    };
    await postJson("https://service.respond.io/webchat/message", servicePayload);
    await postJson(`https://service.respond.io/webchat/${encodeURIComponent(cId)}/message`, servicePayload);
    postToWidget(text);
    window.setTimeout(() => postToWidget(text), 800);
  };

  const sendShopify = async () => {
    if (!shopifyForm) throw new Error("Missing contact form");
    const nameField = shopifyForm.querySelector("[data-buy-contact-name]");
    const emailField = shopifyForm.querySelector("[data-buy-contact-email]");
    const phoneField = shopifyForm.querySelector("[data-buy-contact-phone]");
    const bodyField = shopifyForm.querySelector("[data-buy-contact-body]");
    const fallbackEmail = val("email") || window.theme?.shopEmail || "support@smartfixgy.com";
    if (nameField) nameField.value = `${val("first_name")} ${val("last_name")}`;
    if (emailField) emailField.value = fallbackEmail;
    if (phoneField) phoneField.value = val("phone");
    if (bodyField) bodyField.value = buildMessage();
    document.querySelectorAll('[name="g-recaptcha-response"], [name="recaptcha-v3-token"]').forEach((field) => {
      if (!shopifyForm.querySelector(`[name="${field.name}"]`)) {
        const copy = document.createElement("input");
        copy.type = "hidden";
        copy.name = field.name;
        copy.value = field.value;
        shopifyForm.appendChild(copy);
      } else {
        shopifyForm.querySelector(`[name="${field.name}"]`).value = field.value;
      }
    });
    const action = shopifyForm.getAttribute("action") || `${window.location.origin}/contact`;
    const res = await fetch(action, {
      method: "POST",
      body: new FormData(shopifyForm),
      credentials: "same-origin",
    });
    if (!res.ok && res.status !== 302) throw new Error("Could not send");
  };

  form.addEventListener("change", (event) => {
    if (["need_delivery", "same_address", "same_receiver"].includes(event.target.name)) {
      syncExtras();
    }
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    showError("");
    if (!form.reportValidity()) {
      showError((window.themeI18n?.t || ((k) => k))("required_fields"));
      return;
    }
    if (radio("need_delivery") === "yes" && val("time_from") >= val("time_to")) {
      showError((window.themeI18n?.t || ((k) => k))("time_order"));
      return;
    }
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = (window.themeI18n?.t || ((k) => k))("sending");
    }
    try {
      await sendShopify();
      await sendRespondChat();
      form.reset();
      syncExtras();
      showThanks();
    } catch {
      showError((window.themeI18n?.t || ((k) => k))("send_fail"));
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = (window.themeI18n?.t || ((k) => k))("send");
      }
    }
  });

  form.querySelectorAll("[data-buy-now-close]").forEach((btn) => {
    btn.addEventListener("click", close);
  });
  dialog.addEventListener("cancel", (event) => {
    event.preventDefault();
    close();
  });
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) close();
  });
  thanks?.querySelector("[data-buy-now-thanks-close]")?.addEventListener("click", close);
  thanks?.addEventListener("cancel", (event) => {
    event.preventDefault();
    close();
  });
  thanks?.addEventListener("click", (event) => {
    if (event.target === thanks) close();
  });

  document.addEventListener("click", (event) => {
    const btn = event.target.closest("[data-buy-now]");
    if (!btn || btn.disabled) return;
    event.preventDefault();
    open({
      title: btn.dataset.productTitle || document.querySelector(".product-buy h1")?.textContent?.trim() || "",
      variant: btn.dataset.variant || "",
      sku: btn.dataset.sku || "",
      price: btn.dataset.price || "",
      url: btn.dataset.productUrl || window.location.href,
    });
  });
})();
